/* THIS FILE IS AUTO-GENERATED – DO NOT EDIT */

import {forwardRef, type ForwardRefExoticComponent, type RefAttributes, type SVGProps} from 'react'

/**
 * @public
 */
export const EqualIcon: ForwardRefExoticComponent<
  Omit<SVGProps<SVGSVGElement>, 'ref'> & RefAttributes<SVGSVGElement>
> = /* @__PURE__ */ forwardRef(function EqualIcon(props, ref) {
  return (
    <svg
      data-sanity-icon="equal"
      width="1em"
      height="1em"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={ref}
    >
      <path d="M7.5 4.5H3.5V20.5H7.5" stroke="currentColor" strokeWidth={1.2} />
      <path d="M17.5 20.5L21.5 20.5L21.5 4.5L17.5 4.5" stroke="currentColor" strokeWidth={1.2} />
      <path d="M9 10.5H16" stroke="currentColor" strokeWidth={1.2} />
      <path d="M9 14.5H16" stroke="currentColor" strokeWidth={1.2} />
    </svg>
  )
})

export {EqualIcon as default}
